import { InjectionToken } from '@angular/core';
import { AppStoreConfig } from '@ddt-web/data-service';

export interface AppConfigurationProperties {
	store: AppStoreConfig;
	appName: string;
}

export const AppConfigurationPropertiesService = new InjectionToken<AppConfigurationProperties>('AppConfigurationProperties');
